import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA } from './analytics';
import './i18n/config';

// Initialize Google Analytics (replace with your GA4 Measurement ID)
const GA_MEASUREMENT_ID = process.env.GA_MEASUREMENT_ID || 'G-W9W5QZVZ4H';
initGA(GA_MEASUREMENT_ID);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
